import { Type } from 'class-transformer';
import { RatePayload } from 'services/interfaces/RatePayload';
import { ModelLike, JsonApiPayload } from '../interfaces/JsonApiPayload';

export class SiteTypePayload extends JsonApiPayload {
  id: string;
  parkId: string;
  pmsId: string;
  type: string;
  name: string;
  code: string;
  description: string;
  defaultArrivalTime: string;
  defaultDepartureTime: string;
  maxOccupantsPerSiteType: number;
  maxOccupantsPerSiteTypeType: number;
  bookable: boolean;
  bookableBySiteType: boolean;
  active: boolean;
  siteType: SiteTypePayload;
  altName: string;
  altDescription: string;
  primaryPhoto: any;
  primaryPhotoUrl: string;
  primaryPhotoId: string;
  rateSummary: string;
  universalSiteType: {
    id: string;
    name: string;
    typeName: string;
    description: string;
    hasSleeps: boolean;
    hasUtilities: boolean;
    hasVehicleDetails: boolean;
  }
  maxAdults: number;
  maxChildren: number;
  maxPets: number;
  maxOccupancy: number;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;

  @Type(() => RatePayload)
  rates: RatePayload[];

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    const result = super._getSchema(this, ['rates']);
    return result;
  }
};
